import {BasicEntity} from '../../framework/message/BasicEntity';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';

export class RestorePoint extends BasicEntity {
description: TranslatedEmb;
emID: number | null;
emTime: number | null;
label: TranslatedEmb;
login: string;
range: string;
visionCode: string;
}

